

































































































import SideNavigation from "@/components/SideNavigation.vue";
import { AuthHttp } from "@/mixins/http/auth";
import { MessageHttp } from "@/mixins/http/message";
import { FeedbackHttp } from "@/mixins/http/feedback";
// eslint-disable-next-line no-unused-vars
import { AxiosResponse } from "axios";
import { Component, Mixins } from "vue-property-decorator";
import FeedbackPopup from "@/components/FeedbackPopup.vue";
import OnboardingDialog from "@/components/OnboardingDialog.vue";

@Component({
	components: {
		"side-nav": SideNavigation,
		"feedback-popup": FeedbackPopup,
		"onboarding-dialog": OnboardingDialog,
	},
})
export default class App extends Mixins(AuthHttp, MessageHttp, FeedbackHttp) {
	public showSideNav: boolean = false;
	messages: Array<any> = [];
	showOnboardingDialog: boolean = false;

	mounted() {
		if (localStorage.getItem("access_token") && !this.$store.getters["account/currentUser"]) {
			this.getCurrentUser()
				.then((response: AxiosResponse) => {
					this.$store.dispatch("account/updateCurrentUser", response.data);

					this.getMessagesForRecipient(response.data.userId).then(
						(response: AxiosResponse<any>) => {
							this.messages = response.data;
						}
					);

					this.showOnboardingDialog = this.$store.getters["account/currentUser"].neverLoggedIn;

					if (this.$route.path == "" || this.$route.path == "/") {
						this.$router.push("/dashboard");
					}
				})
				.catch(() => {
					this.$router.push("/auth/login");
				});
		} else if (localStorage.getItem("access_token") && this.$store.getters["account/currentUser"]) {
			this.getMessagesForRecipient(this.$store.getters["account/currentUser"].id).then(
				(response: AxiosResponse<any>) => {
					this.messages = response.data;
				}
			);

			this.showOnboardingDialog = this.$store.getters["account/currentUser"].neverLoggedIn;

			if (this.$route.path == "" || this.$route.path == "/") {
				this.$router.push("/dashboard");
			}
		}

		this.showSideNav = this.$vuetify.breakpoint.lgAndUp;
	}
	sideNavToggleValueChanged(toggledValue: boolean) {
		this.showSideNav = toggledValue;
	}

	logout(): void {
		this.clearAccessTokenFromLocalStorage();
		this.clearAuthDataFromStore();
		this.$router.push("/auth/login");
	}

	clearAccessTokenFromLocalStorage() {
		localStorage.removeItem("access_token");
	}

	clearAuthDataFromStore() {
		this.$store.dispatch("account/resetStore");
	}

	setMessagesAsViewed(): void {
		let messagesToSetAsViewed: Array<any> = this.messages
			.filter((m) => !m.readOn)
			.map((m) => m._id);

		if (messagesToSetAsViewed.length > 0) {
			let updates = {
				messages: messagesToSetAsViewed,
				read: true,
			};
			this.updateMessagesForRecipient(updates);
		}
	}

	get unreadMessages(): Array<any> {
		return this.messages.filter((message) => !message.readOn);
	}
}
